import { FormResponseValueAnswer } from "@tellescope/types-models";

export const evaluateResponseEquals = (answer: FormResponseValueAnswer, comparison: string) => {
  if (answer.type === "Database Select" && answer.value?.length) {
    return !!answer.value.find((v) => v?.text === comparison);
  }

  if (answer.type === "Insurance") {
    return answer.value?.payerName === comparison;
  }

  if (
    answer.type === "Bridge Eligibility" ||
    answer.type === "Candid Eligibility" ||
    answer.type === "Stedi Eligibility"
  ) {
    return answer.value?.status === comparison;
  }

  if (answer.type === "Address") {
    return (
      comparison === answer.value?.state || comparison === answer.value?.zipCode || comparison === answer.value?.city
    );
  }

  if (Array.isArray(answer.value)) return (answer.value as string[]).includes(comparison);

  // `equals` is always stored as a string, so a numeric answer has to be stringified to compare —
  // otherwise a number field can never satisfy any equality condition.
  if (typeof answer.value === "number") return answer.value.toString() === comparison;

  return answer.value === comparison;
};
